export default __webpack_public_path__ + "static/media/297.aa0eaf51.jpg";